/**
 * StatusBadge
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Badge } from 'react-bootstrap';

function StatusBadge(props) {
  const { className = 'ms-2', children } = props;
  return <Badge className={classNames(['bg-gray text-dark fw-normal', className])}>{children}</Badge>;
}

StatusBadge.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default StatusBadge;
